export default "__VITE_ASSET__DqOHNlhD__"